import { track } from "../track";

export const trackProductUrlSubmit = (params: { url: string }) =>
  track({ event: "product_url_submit", ...params });
